module.exports = __webpack_public_path__ + "static/media/013.514da588.jpg";